import React from 'react';
import { Layout } from '@/components/layout/Layout';
import Seo from '@/components/Seo';

export default function TermsPage() {
  return (
    <Layout>
      <Seo
        title="Terms of Service"
        description="Read the terms and conditions for using yBro services."
        path="/terms"
      />
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-black font-heading text-slate-900 mb-8">
            Terms of Service
          </h1>
          <p className="text-slate-600 font-body leading-relaxed mb-6">
            These Terms govern your use of the yBro website and services. By using
            our site or engaging our services, you agree to these Terms.
          </p>

          <div className="space-y-8 text-slate-600 font-body leading-relaxed">
            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Company details</h2>
              <p>
                yBro Limited, 124 City Road, London, EC1V 2NX, UK. Contact:
                <a href="mailto:hello@ybro.com" className="text-ybro-primary"> hello@ybro.com</a>.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Services</h2>
              <p>
                We provide GBP management, review handling, local SEO, and compliance
                support services. Specific deliverables, timelines, and fees are set
                out in your agreement or proposal.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Payments</h2>
              <p>
                Fees are payable as agreed in your proposal or invoice. Late payments
                may result in service suspension until balances are settled.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Client responsibilities</h2>
              <p>
                You agree to provide accurate information and timely access needed
                to deliver services. You are responsible for decisions and actions
                based on our recommendations.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Liability</h2>
              <p>
                To the maximum extent permitted by law, yBro is not liable for
                indirect or consequential losses. Our total liability is limited to
                the fees paid for the services in question.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Termination</h2>
              <p>
                Either party may terminate services by providing written notice in
                accordance with the agreement terms.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Governing law</h2>
              <p>
                These Terms are governed by the laws of England and Wales, and courts
                of that jurisdiction have exclusive authority.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold font-heading text-slate-900 mb-3">Updates</h2>
              <p>
                We may update these Terms from time to time. Continued use of the
                site indicates acceptance of the updated Terms.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
